import { render, staticRenderFns } from "./RecoveryCodeForm.vue?vue&type=template&id=533b087b&scoped=true&"
import script from "./RecoveryCodeForm.vue?vue&type=script&lang=js&"
export * from "./RecoveryCodeForm.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryCodeForm.vue?vue&type=style&index=0&id=533b087b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533b087b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})
